module.exports = __webpack_public_path__ + "img/classification5.e4107ba6.png";